import React, { useEffect, useState, createElement } from 'react';
import { cn } from '@/lib/utils';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { UrgencyModule } from './components/UrgencyModule';
import { CheckIcon, XIcon, ShieldIcon, StarIcon, ChevronDownIcon, HeartIcon, SparklesIcon, CrownIcon, LockIcon } from 'lucide-react';
const PURCHASE_URL = 'https://zdn5g0-8y.myshopify.com/cart/46443612143789:1?channel=buy_button';
const MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function getTodayInSpanish() {
  const today = new Date();
  const day = today.getDate();
  const month = MESES_ES[today.getMonth()];
  return `${day} de ${month}`;
}
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [todayLabel] = useState(getTodayInSpanish());
  const [selectedTestimonial, setSelectedTestimonial] = useState<string | null>(null);
  useEffect(() => {
    if (!selectedTestimonial) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setSelectedTestimonial(null);
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [selectedTestimonial]);
  // Meta Pixel
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1356194843124588');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1356194843124588&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-[#0a0000] text-slate-200 font-sans selection:bg-[#d4af37] selection:text-black" data-id="element-0">
      <PurchasePopup data-id="element-1" />
      <ExitIntentPopup data-id="element-2" />

      {/* Lightbox de testimonios */}
      {selectedTestimonial && <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 md:p-8" onClick={() => setSelectedTestimonial(null)} role="dialog" aria-modal="true" aria-label="Testimonio ampliado" data-id="element-3">
          <button type="button" onClick={() => setSelectedTestimonial(null)} aria-label="Cerrar" className="absolute top-4 right-4 md:top-6 md:right-6 bg-black/70 border border-[#d4af37]/50 text-[#d4af37] rounded-full p-2 hover:bg-[#d4af37] hover:text-black transition-colors z-10" data-id="element-4">
            <XIcon className="h-6 w-6" data-id="element-5" />
          </button>
          <img src={selectedTestimonial} alt="Testimonio ampliado" onClick={e => e.stopPropagation()} className="max-w-full max-h-[90vh] w-auto h-auto object-contain rounded-2xl border-2 border-[#d4af37] shadow-[0_0_40px_rgba(212,175,55,0.4)]" data-id="element-6" />
        </div>}

      {/* 1. Barra superior de urgencia */}
      <div className="w-full bg-gradient-to-r from-red-950 via-black to-red-950 text-white py-3 px-4 text-center sticky top-0 z-50 border-b border-[#d4af37]/30 shadow-[0_4px_20px_rgba(0,0,0,0.8)] relative overflow-hidden" data-id="element-7">
        <div className="absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(212,175,55,0.05)_50%,transparent_100%)]" data-id="element-8"></div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-9">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm" data-id="element-10">
            <span className="flex items-center gap-2" data-id="element-11">
              <SparklesIcon className="h-4 w-4 text-[#d4af37] animate-pulse" data-id="element-12" />
              <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#d4af37] uppercase tracking-widest drop-shadow-sm" data-id="element-13">
                Oferta exclusiva solo por hoy {todayLabel}
              </span>{' '}
              <span className="text-slate-400 font-medium hidden sm:inline" data-id="element-14">
                — Expira en:
              </span>{' '}
              <CountdownTimer data-id="element-15" />
            </span>
          </div>
        </div>
      </div>

      {/* 2. Hero principal */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-red-950/40 via-[#0a0000] to-black py-16 px-4 relative overflow-hidden mt-[-40px] mb-[-40px]" data-id="element-16">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-red-900/20 rounded-full blur-[120px] pointer-events-none" data-id="element-17"></div>
        <div className="absolute bottom-0 left-1/4 w-72 h-72 bg-[#d4af37]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-18"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-19">
          <div className="flex justify-center mb-8" data-id="element-20">
            <div className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-[#d4af37]/30 bg-black/60 backdrop-blur-md shadow-[0_0_20px_rgba(212,175,55,0.15)]" data-id="element-21">
              <CrownIcon className="h-4 w-4 text-[#d4af37]" data-id="element-22" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-23">
                Trato de Reina — Reto de 21 Días
              </span>
            </div>
          </div>

          <h1 className="md:text-7xl font-black text-white mb-6 uppercase text-center tracking-tight font-serif text-[30px]" data-id="element-24">
            Hace que tu hombre te{' '}
            <span className="text-[#d4af37] drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-25">
              valore
            </span>
            , te{' '}
            <span className="text-[#d4af37] drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-26">
              cuide
            </span>
            , te{' '}
            <span className="text-[#d4af37] drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-27">
              priorice
            </span>{' '}
            y haga todo por
            <span className="text-[#d4af37] drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-28">
              {' '}
              no perderte
            </span>{' '}
            en menos de 21 días✨💋
          </h1>

          <div className="max-w-3xl mx-auto mb-10 relative group" data-id="element-29">
            <div className="absolute inset-0 bg-[#d4af37]/30 rounded-2xl blur-2xl group-hover:bg-[#d4af37]/40 transition-all duration-500" data-id="element-30"></div>
            <img src="https://cdn.magicpatterns.com/uploads/uHf2SKxwopQiyEkhwnhfqb/1.png" alt="Trato de Reina" className="w-full h-auto relative z-10 group-hover:scale-[1.02] transition-transform duration-500 rounded-2xl border-2 border-[#d4af37] shadow-[0_0_30px_rgba(212,175,55,0.6),0_0_60px_rgba(212,175,55,0.3)]" data-id="element-31" />
          </div>

          <p className="md:text-2xl text-slate-300 max-w-3xl mx-auto text-center text-[20px] font-[400] mt-[15px] mb-[15px]" data-id="element-32">
            Dejá de perseguirlo.... cambiá la estrategia con mi método probado.
            Él hará todo por no perderte y te tratará como una Reina.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-33">
            {['Sin perseguirlo.', 'Sin rogarle.', 'Sin pedirle que te elija.'].map((text, i) => <span key={i} className="bg-red-950/50 border border-red-900/50 text-red-200 px-4 py-2 rounded-full text-sm font-medium" data-id="element-34">
                {text}
              </span>)}
          </div>

          <p className="text-lg md:text-xl text-[#d4af37] mb-10 max-w-2xl mx-auto text-center font-medium italic" data-id="element-35">
            "Es momento de dejar de conformarte con migajas y empezar a recibir
            el Trato de Reina que merecés."
          </p>

          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-red-800 to-red-950 text-white font-black md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(153,27,27,0.4)] hover:shadow-[0_0_50px_rgba(153,27,27,0.6)] transform hover:scale-105 transition-all duration-300 uppercase text-center border border-red-700 w-full md:w-auto text-[25px] animate-pulse-slow" data-id="element-36">
            QUIERO MI TRATO DE REINA{' '}
            <span className="inline-block neon-emoji" data-id="element-37">👑</span>
          </a>
          <p className="text-sm text-slate-400 mt-4 font-medium tracking-wide" data-id="element-38">
            Acceso inmediato · Pago único · Acceso de por vida
          </p>
        </div>
      </section>

      {/* 3. Identificación con el dolor */}
      <section className="w-full bg-[#050000] py-20 px-4 relative overflow-hidden border-t border-white/5 pt-[7px] pb-[7px]" data-id="element-39">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-12 text-center uppercase leading-tight font-serif" data-id="element-41">
            ¿Te sentís identificada con esto?
          </h2>

          <div className="bg-black/50 rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)] p-8 md:p-12 border border-red-900/30 relative overflow-hidden" data-id="element-42">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-800" data-id="element-43"></div>

            <div className="space-y-6" data-id="element-44">
              {['Sentís que perseguís demasiado a un hombre y siempre das más de lo que recibís.', 'No te sentís priorizada y te conformás con las sobras de su tiempo.', 'Tenés miedo de poner límites porque pensás que se va a alejar.', 'Sentís que perdiste tu esencia y tu brillo dentro de una relación.', 'Estás cansada de rogar por atención, detalles y cuidado.'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-red-950/20 p-5 rounded-2xl border border-red-900/20" data-id="element-45">
                  <div className="bg-red-900/40 rounded-full p-2 flex-shrink-0 mt-0.5" data-id="element-46">
                    <XIcon className="h-5 w-5 text-red-400 neon-red" data-id="element-47" />
                  </div>
                  <span className="text-slate-300 font-medium leading-relaxed text-lg" data-id="element-48">
                    {text}
                  </span>
                </div>)}
            </div>

            <div className="mt-10 text-center" data-id="element-49">
              <p className="inline-block bg-red-950/50 text-red-200 px-8 py-4 rounded-xl text-lg font-bold border border-red-800/50 italic" data-id="element-50">
                No es tu culpa. Nadie nos enseñó a habitar nuestra energía
                femenina.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Visualización de la transformación */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1a0505] via-black to-black py-20 px-4 relative overflow-hidden pt-[7px] pb-[7px]" data-id="element-51">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-[#d4af37]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-52"></div>

        <div className="max-w-5xl mx-auto relative z-10 pt-[-25px] pb-[-25px]" data-id="element-53">
          <div className="text-center mb-16" data-id="element-54">
            <CrownIcon className="h-12 w-12 text-[#d4af37] mx-auto mb-6" data-id="element-55" />
            <h2 className="text-4xl md:text-6xl font-black text-white mb-6 uppercase font-serif" data-id="element-56">
              Imaginá cómo sería tu vida si pudieras...
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-57">
            {['Dejar de perseguir atención y empezar a atraerla naturalmente.', 'Recuperar tu energía femenina y tu magnetismo.', 'Volver a sentirte deseada, segura y poderosa.', 'Elevar tus estándares y dejar de aceptar migajas de amor.', 'Aprender a poner límites desde el amor propio, no desde el enojo.', 'Convertirte en una mujer priorizada, valorada y difícil de perder.', 'Volver a elegirte a vos misma por encima de cualquier otra persona.', 'Aprender a recibir amor, atención, detalles y cuidado como una verdadera reina.'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-black/60 p-6 rounded-2xl border border-[#d4af37]/20 hover:border-[#d4af37]/50 transition-colors group" data-id="element-58">
                <div className="bg-[#d4af37]/10 rounded-full p-2 flex-shrink-0 mt-0.5 group-hover:bg-[#d4af37]/20 transition-colors" data-id="element-59">
                  <HeartIcon className="h-5 w-5 text-[#d4af37]" data-id="element-60" />
                </div>
                <span className="text-slate-200 font-medium text-lg leading-relaxed" data-id="element-61">
                  {text}
                </span>
              </div>)}
          </div>

          {/* NUEVAS SECCIONES AGREGADAS */}
          {/* SECCIÓN 1: LO QUE VAS A APRENDER */}
          <div className="mt-0 mb-24 relative z-10" data-id="element-62">
            <div className="text-center mb-16" data-id="element-63">
              <h2 className="text-4xl md:text-6xl font-black text-white uppercase font-serif mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.5)] pt-[10px] pb-[10px]" data-id="element-64">
                LO QUE VAS A APRENDER CON{' '}
                <span className="text-[#d4af37]" data-id="element-65">TRATO DE REINA</span>
              </h2>
              <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto font-light" data-id="element-66">
                Esto no es simplemente otro ebook para “ser más femenina”.
                <br data-id="element-67" />
                <span className="text-[#d4af37] font-medium mt-2 inline-block" data-id="element-68">
                  Es una transformación emocional, energética y mental de 21
                  días.
                </span>
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16" data-id="element-69">
              {['Convertirte en esa mujer que un hombre no quiere perder.', 'Activar tu poder femenino para recibir amor, atención, cuidado y detalles.', 'Dejar de perseguir, insistir y pedir explicaciones constantemente.', 'Recuperar tu misterio y tu magnetismo personal.', 'Poner límites sin miedo a que él se ofenda o se aleje.', 'Elevar tu autoestima sin depender de su validación.', 'Dejar de ocupar el rol de quien siempre sostiene y persigue.', 'Convertirte en una mujer segura, deseada y difícil de reemplazar.', 'Reconocer cuándo te están dando migajas.', 'Aprender a recibir sin culpa y sin sentir que tenés que ganártelo todo.'].map((text, i) => <div key={i} className="bg-black/60 border border-[#d4af37]/30 p-6 rounded-2xl hover:border-[#d4af37]/60 transition-all duration-300 flex items-start gap-4 shadow-[0_0_15px_rgba(212,175,55,0.1)] hover:shadow-[0_0_25px_rgba(212,175,55,0.2)] hover:-translate-y-1" data-id="element-70">
                  <span className="text-2xl neon-emoji" data-id="element-71">👑</span>
                  <span className="text-slate-200 font-medium text-lg leading-relaxed" data-id="element-72">
                    {text}
                  </span>
                </div>)}
            </div>
            <div className="text-center" data-id="element-73">
              <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-red-800 to-red-950 text-white font-black md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(153,27,27,0.4)] hover:shadow-[0_0_50px_rgba(153,27,27,0.6)] transform hover:scale-105 transition-all duration-300 uppercase text-center border border-red-700 text-[25px] animate-pulse-slow" data-id="element-74">
                QUIERO ACTIVAR MI PODER FEMENINO{' '}
                <span className="inline-block neon-emoji" data-id="element-75">✨</span>
              </a>
            </div>
          </div>

          {/* SECCIÓN 2: MÉTODO CORONA */}
          <div className="mt-[-24px] mb-24 relative z-10" data-id="element-76">
            <div className="text-center mb-16" data-id="element-77">
              <h2 className="text-4xl md:text-6xl font-black text-white uppercase font-serif mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.5)]" data-id="element-78">
                CONOCÉ EL MÉTODO{' '}
                <span className="text-[#d4af37]" data-id="element-79">CORONa👑</span>
              </h2>
              <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto font-light" data-id="element-80">
                La transformación paso a paso que vas a recorrer durante los
                próximos 21 días.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-81">
              {[{
              letter: 'C',
              title: 'CORTÁ LA PERSECUCIÓN',
              desc: 'Dejá de actuar desde la ansiedad, la desesperación y el miedo a perderlo.',
              icon: <XIcon className="h-8 w-8 text-[#d4af37]" data-id="element-82" />
            }, {
              letter: 'O',
              title: 'OCUPÁ TU LUGAR',
              desc: 'Recuperá tus estándares, tu dignidad y tu valor como mujer.',
              icon: <CrownIcon className="h-8 w-8 text-[#d4af37]" data-id="element-83" />
            }, {
              letter: 'R',
              title: 'REACTIVÁ TU ENERGÍA FEMENINA',
              desc: 'Volvé a conectar con tu magnetismo, tu suavidad, tu presencia y tu capacidad de recibir.',
              icon: <SparklesIcon className="h-8 w-8 text-[#d4af37]" data-id="element-84" />
            }, {
              letter: 'O',
              title: 'ORDENÁ TUS LÍMITES',
              desc: 'Aprendé qué aceptar, qué rechazar y cómo mantenerte firme.',
              icon: <ShieldIcon className="h-8 w-8 text-[#d4af37]" data-id="element-85" />
            }, {
              letter: 'N',
              title: 'NUTRÍ TU DESEO Y TU PRESENCIA',
              desc: 'Transformate en una mujer que se siente segura, atractiva y poderosa.',
              icon: <HeartIcon className="h-8 w-8 text-[#d4af37]" data-id="element-86" />
            }, {
              letter: 'A',
              title: 'ACTUÁ COMO UNA REINA',
              desc: 'Dejá de comportarte desde el miedo y empezá a tomar decisiones desde tu valor.',
              icon: <StarIcon className="h-8 w-8 text-[#d4af37]" data-id="element-87" />
            }].map((item, i) => <div key={i} className="bg-gradient-to-b from-red-950/30 to-black border border-[#d4af37]/20 p-8 rounded-3xl hover:border-[#d4af37]/50 transition-all duration-300 relative overflow-hidden group" data-id="element-88">
                  <div className="absolute -right-4 -top-4 text-9xl font-black text-[#d4af37]/5 group-hover:text-[#d4af37]/10 transition-colors font-serif" data-id="element-89">
                    {item.letter}
                  </div>
                  <div className="relative z-10" data-id="element-90">
                    <div className="flex items-center gap-4 mb-6" data-id="element-91">
                      <div className="text-5xl font-black text-[#d4af37] font-serif drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-92">
                        {item.letter}
                      </div>
                      <div className="bg-black/50 p-3 rounded-full border border-[#d4af37]/30" data-id="element-93">
                        {item.icon}
                      </div>
                    </div>
                    <h3 className="text-xl font-black text-white mb-4 uppercase tracking-wide" data-id="element-94">
                      {item.title}
                    </h3>
                    <p className="text-slate-300 leading-relaxed" data-id="element-95">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* SECCIÓN 3: CONTENIDO DEL RETO DE 21 DÍAS */}
          <div className="mt-32 mb-4 relative z-10 bg-black/40 border border-white/5 rounded-[3rem] p-8 md:p-16 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-96">
            <div className="text-center mb-16" data-id="element-97">
              <h2 className="md:text-6xl font-black text-white uppercase font-serif drop-shadow-[0_0_15px_rgba(212,175,55,0.5)] text-[29px] mt-[-110px] mb-[-70px]" data-id="element-98">
                TU TRANSFORMACIÓN DURANTE LOS{' '}
                <span className="text-[#d4af37] text-[25px]" data-id="element-99">
                  PRÓXIMOS 21 DÍAS
                </span>
              </h2>
            </div>

            <div className="relative max-w-4xl mx-auto" data-id="element-100">
              {/* Línea vertical */}
              <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-[#d4af37]/20 via-[#d4af37] to-[#d4af37]/20 md:-translate-x-1/2" data-id="element-101"></div>

              <div className="space-y-12" data-id="element-102">
                {[{
                days: 'DÍAS 1 AL 4',
                title: 'DEJAR DE PERSEGUIR',
                desc: 'Vas a entender por qué lo buscás, por qué necesitás respuestas y por qué él parece alejarse cuanto más insistís.'
              }, {
                days: 'DÍAS 5 AL 8',
                title: 'RECUPERAR TU VALOR',
                desc: 'Vas a reconectar con tu identidad, tu autoestima y la mujer que eras antes de olvidarte de vos.'
              }, {
                days: 'DÍAS 9 AL 12',
                title: 'ELEVAR TUS ESTÁNDARES',
                desc: 'Vas a definir lo que merecés, lo que ya no aceptás y cómo dejar de conformarte con poco.'
              }, {
                days: 'DÍAS 13 AL 16',
                title: 'ACTIVAR TU ENERGÍA FEMENINA',
                desc: 'Vas a trabajar tu presencia, tu forma de recibir, tu lenguaje corporal y tu magnetismo.'
              }, {
                days: 'DÍAS 17 AL 19',
                title: 'CONVERTIRTE EN UNA MUJER PRIORIZADA',
                desc: 'Vas a cambiar la manera en la que te relacionás, hablás y reaccionás.'
              }, {
                days: 'DÍAS 20 Y 21',
                title: 'RECIBIR TU CORONA',
                desc: 'Vas a consolidar tu nueva identidad y crear las reglas de la mujer que nunca más vuelve a mendigar amor.'
              }].map((step, i) => <div key={i} className={cn(`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`, 'pt-[10px] pb-[10px]')} data-id="element-103">
                    {/* Punto en la línea */}
                    <div className="absolute left-0 md:left-1/2 w-14 h-14 bg-black border-4 border-[#d4af37] rounded-full md:-translate-x-1/2 flex items-center justify-center shadow-[0_0_15px_rgba(212,175,55,0.5)] z-10" data-id="element-104">
                      <span className="text-[#d4af37] font-black text-sm" data-id="element-105">
                        {i + 1}
                      </span>
                    </div>

                    {/* Contenido */}
                    <div className={`ml-20 md:ml-0 w-full md:w-1/2 ${i % 2 === 0 ? 'md:pl-16 text-left' : 'md:pr-16 md:text-right'}`} data-id="element-106">
                      <div className="bg-gradient-to-r from-red-950/20 to-black border border-[#d4af37]/30 p-6 rounded-2xl hover:border-[#d4af37]/60 transition-colors" data-id="element-107">
                        <span className="inline-block bg-[#d4af37]/10 text-[#d4af37] px-3 py-1 rounded-full text-xs font-black tracking-widest mb-3 border border-[#d4af37]/20" data-id="element-108">
                          {step.days}
                        </span>
                        <h3 className="text-2xl font-black text-white mb-3 uppercase font-serif" data-id="element-109">
                          {step.title}
                        </h3>
                        <p className="text-slate-300 text-[16px]" data-id="element-110">
                          {step.desc}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>

              {/* Gráfico de progreso visual */}
              <div className="mt-20 bg-black/60 border border-[#d4af37]/30 rounded-full p-4 flex items-center justify-between relative overflow-hidden" data-id="element-111">
                <div className="absolute left-0 top-0 bottom-0 w-full bg-gradient-to-r from-[#d4af37]/10 to-[#d4af37]/30" data-id="element-112"></div>
                <div className="relative z-10 flex items-center justify-between w-full px-4" data-id="element-113">
                  <span className="text-white font-bold text-sm md:text-base" data-id="element-114">
                    DÍA 1
                  </span>
                  <div className="flex-1 mx-4 h-2 bg-black rounded-full overflow-hidden border border-white/10" data-id="element-115">
                    <div className="w-full h-full bg-gradient-to-r from-red-800 via-[#d4af37] to-[#d4af37] animate-pulse" data-id="element-116"></div>
                  </div>
                  <span className="text-[#d4af37] font-black text-sm md:text-base flex items-center gap-2" data-id="element-117">
                    DÍA 21 <CrownIcon className="h-5 w-5" data-id="element-118" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Módulo de Testimonios */}
          <div className="mt-4 mb-16" data-id="element-119">
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase font-serif mb-12 text-center pb-[25px]" data-id="element-120">
              ESTO DICEN LAS QUE YA TIENEN{' '}
              <span className="text-[#d4af37]" data-id="element-121">TRATO DE REINA</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-122">
              {['https://cdn.magicpatterns.com/uploads/5yx5jR5qusTFk7Vo9i93fc/TESTIMONIO_1.png', 'https://cdn.magicpatterns.com/uploads/kRUg3QgLydnhGdaMv1S5An/TESTIMONIO_2.png', 'https://cdn.magicpatterns.com/uploads/1WoUy3JN5GoHqLLZrW2KZZ/TESTIMONIO_3.png', 'https://cdn.magicpatterns.com/uploads/3mUfrZBn6WiBCtQzFv9dyn/TESTIMONIO_5.png', 'https://cdn.magicpatterns.com/uploads/5PPfqejk7cn12oxsD3DcYU/TESTIMONIO_6.png', 'https://cdn.magicpatterns.com/uploads/kxFx5TcEwSYHBYpo1WZBK5/TESTIMONIO_7.png', 'https://cdn.magicpatterns.com/uploads/5yjeds7zNTNXtGFQzEfWsf/TESTIMONIO_8.png', 'https://cdn.magicpatterns.com/uploads/845bnhA8kMhQ3CvcxwW9Nj/TESTIMONIO_10.png'].map((img, i) => <button key={i} type="button" onClick={() => setSelectedTestimonial(img)} aria-label={`Ampliar testimonio ${i + 1}`} className="relative group overflow-hidden rounded-2xl border border-white/10 shadow-2xl hover:border-[#d4af37]/50 transition-all duration-500 cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-[#d4af37]" data-id="element-123">
                  <img src={img} alt={`Testimonio ${i + 1}`} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-124" />
                  <span className="absolute bottom-3 right-3 bg-black/70 text-[#d4af37] text-xs font-bold px-3 py-1 rounded-full border border-[#d4af37]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-125">
                    Tocá para ampliar
                  </span>
                </button>)}
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-126">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-[#d4af37] to-[#aa8c2c] text-black font-black md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.3)] hover:shadow-[0_0_50px_rgba(212,175,55,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-[25px] pt-[20px] pb-[20px] animate-pulse-slow" data-id="element-127">
              QUIERO ESTA TRANSFORMACIÓN
            </a>
          </div>
        </div>
      </section>

      {/* 5. Para quién es y para quién no es */}
      <section className="w-full bg-[#050000] py-20 px-4 relative overflow-hidden border-y border-white/5 pt-[25px] pb-[25px]" data-id="element-128">
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-129">
          <h2 className="md:text-5xl font-black text-white mb-16 text-center uppercase font-serif text-[35px]" data-id="element-130">
            ¿Es este reto para vos?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-131">
            {/* Para quién SÍ es */}
            <div className="bg-gradient-to-b from-[#1a0f00] to-black rounded-3xl p-8 md:p-10 border border-[#d4af37]/30 relative overflow-hidden" data-id="element-132">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#d4af37]" data-id="element-133"></div>
              <h3 className="text-2xl font-black text-[#d4af37] mb-8 uppercase text-center" data-id="element-134">
                Este reto SÍ es para vos si:
              </h3>
              <ul className="space-y-5" data-id="element-135">
                {['Estás dispuesta a hacer el trabajo interno para cambiar tus patrones.', 'Querés dejar de ser la "buena" que siempre sale lastimada.', 'Estás lista para elevar tus estándares y no conformarte.', 'Querés aprender a conectar con tu energía femenina receptiva.', 'Buscás resultados reales y estás comprometida con vos misma.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-136">
                    <CheckIcon className="h-6 w-6 text-[#d4af37] flex-shrink-0 mt-0.5" data-id="element-137" />
                    <span className="text-slate-300 text-lg" data-id="element-138">{text}</span>
                  </li>)}
              </ul>
            </div>

            {/* Para quién NO es */}
            <div className="bg-gradient-to-b from-[#1a0505] to-black rounded-3xl p-8 md:p-10 border border-red-900/30 relative overflow-hidden" data-id="element-139">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-800 via-red-600 to-red-800" data-id="element-140"></div>
              <h3 className="font-black text-red-500 mb-8 uppercase text-center text-[26px]" data-id="element-141">
                Este reto NO es para vos si:
              </h3>
              <ul className="space-y-5" data-id="element-142">
                {['Buscás "trucos mágicos" sin hacer nada', 'No estás dispuesta a cambiar', 'Preferís seguir quejándote en lugar de tomar acción.', 'Si queres seguir siendo ignorada', 'No estás dispuesta a invertir tiempo y energía en vos misma.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-143">
                    <XIcon className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5 neon-red" data-id="element-144" />
                    <span className="text-slate-300 text-lg" data-id="element-145">{text}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 10. Sección de 6 bonos gratis */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#1a0505] via-black to-black py-20 px-4 relative overflow-hidden pt-[25px] pb-[25px]" data-id="element-146">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4af37]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-147"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-148"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-149">
          <div className="text-center mb-16" data-id="element-150">
            <div className="flex flex-col items-center mb-6" data-id="element-151">
              <span className="text-5xl md:text-6xl neon-emoji mb-2" data-id="element-152">🎁</span>
              <span className="text-[#d4af37] font-black uppercase tracking-[0.3em] text-sm md:text-base" data-id="element-153">
                OBSEQUIO
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase font-serif mb-6" data-id="element-154">
              ACCEDE AHORA Y LLEVATE ESTOS{' '}
              <span className="text-[#d4af37]" data-id="element-155">6 BONOS DE REGALO</span>
            </h2>
            <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto font-light" data-id="element-156">
              Todo lo que necesitás para sentirte acompañada, elevar tu energía
              femenina y sostener tu transformación como una verdadera reina.
            </p>
          </div>

          <div className="space-y-12" data-id="element-157">
            {/* Bono 1 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-158">
              <div className="w-full md:w-1/2 relative" data-id="element-159">
                <img src="https://cdn.magicpatterns.com/uploads/wSpLvPPUQBndY79BE79fvv/2.png" alt="Comunidad Privada Mujeres con Trato de Reina" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-160" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-161">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-162">
                  BONO 1
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-163">
                  COMUNIDAD PRIVADA MUJERES CON TRATO DE REINA
                </h3>
                <p className="text-[#d4af37] font-bold mb-4 tracking-wider text-sm" data-id="element-164">
                  ACCESO EXCLUSIVO EN TELEGRAM
                </p>
                <p className="text-xl text-slate-200 font-medium italic mb-4" data-id="element-165">
                  Sentite acompañada y apoyada en tu proceso de transformación.
                </p>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-166">
                  Accedé a una comunidad privada de mujeres que están
                  recorriendo el mismo camino que vos. Un espacio íntimo y
                  exclusivo para compartir avances, recibir apoyo, sentirte
                  acompañada y reforzar tu nueva identidad de reina.
                </p>
                <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-167">
                  <CrownIcon className="h-5 w-5" data-id="element-168" /> LLÉVATELO GRATIS
                </div>
                <div className="mt-4 flex items-center gap-2" data-id="element-169">
                  <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-170">
                    ARS 14.990
                  </span>
                  <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-171">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-172">
              <div className="w-full md:w-1/2 relative" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/voYv8jGRCpTeZJdCoBDwdu/3.png" alt="Mujer de Alto Valor" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-174" />
              </div>
              <div className="w-full md:w-1/2 text-left md:text-right" data-id="element-175">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-176">
                  BONO 2
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-177">
                  MUJER DE ALTO VALOR
                </h3>
                <p className="text-[#d4af37] font-bold mb-4 tracking-wider text-sm" data-id="element-178">
                  SEGURIDAD, ESTÁNDARES Y PODER FEMENINO
                </p>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-179">
                  Descubrí cómo convertirte en una mujer más segura, valiosa,
                  firme y difícil de reemplazar. Aprendé a elevar tus estándares
                  y a dejar de aceptar menos de lo que merecés.
                </p>
                <div className="flex flex-col items-start md:items-end gap-4" data-id="element-180">
                  <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-181">
                    <CrownIcon className="h-5 w-5" data-id="element-182" /> LLÉVATELO GRATIS
                  </div>
                  <div className="flex items-center gap-2" data-id="element-183">
                    <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-184">
                      ARS 18.990
                    </span>
                    <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-185">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-186">
              <div className="w-full md:w-1/2 relative" data-id="element-187">
                <img src="https://cdn.magicpatterns.com/uploads/2rTUo6zxoDEw8gCS98NfPi/4.png" alt="Desbloqueá tu Magnetismo Femenino" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-188" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-189">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-190">
                  BONO 3
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-191">
                  DESBLOQUEÁ TU MAGNETISMO FEMENINO
                </h3>
                <p className="text-[#d4af37] font-bold mb-4 tracking-wider text-sm" data-id="element-192">
                  ATRAÉ SIN PERSEGUIR
                </p>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-193">
                  Aprendé a activar tu magnetismo y tu presencia para dejar de
                  perseguir atención y empezar a irradiar una energía que atrae,
                  cautiva y deja huella.
                </p>
                <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-194">
                  <CrownIcon className="h-5 w-5" data-id="element-195" /> LLÉVATELO GRATIS
                </div>
                <div className="mt-4 flex items-center gap-2" data-id="element-196">
                  <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-197">
                    ARS 16.990
                  </span>
                  <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-198">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-199">
              <div className="w-full md:w-1/2 relative" data-id="element-200">
                <img src="https://cdn.magicpatterns.com/uploads/jCGvCHFNb5tCJuGgX8U1Lm/5.png" alt="La Biblia de las Reinas" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-201" />
              </div>
              <div className="w-full md:w-1/2 text-left md:text-right" data-id="element-202">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-203">
                  BONO 4
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-204">
                  LA BIBLIA DE LAS REINAS
                </h3>
                <p className="text-[#d4af37] font-bold mb-4 tracking-wider text-sm" data-id="element-205">
                  SABIDURÍA, PODER FEMENINO Y TRATO DE REINA
                </p>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-206">
                  Una guía poderosa para que internalices la mentalidad, los
                  principios y la energía de una mujer que conoce su valor y
                  sabe cómo posicionarse como reina.
                </p>
                <div className="flex flex-col items-start md:items-end gap-4" data-id="element-207">
                  <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-208">
                    <CrownIcon className="h-5 w-5" data-id="element-209" /> LLÉVATELO GRATIS
                  </div>
                  <div className="flex items-center gap-2" data-id="element-210">
                    <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-211">
                      ARS 22.990
                    </span>
                    <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-212">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bono 5 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-213">
              <div className="w-full md:w-1/2 relative" data-id="element-214">
                <img src="https://cdn.magicpatterns.com/uploads/tv2HgmSHdfC1Cxh3bUZ3qE/6.png" alt="Glow Up de Reina" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-215" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-216">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-217">
                  BONO 5
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-218">
                  GLOW UP DE REINA
                </h3>
                <p className="text-[#d4af37] font-bold mb-4 tracking-wider text-sm" data-id="element-219">
                  BELLEZA, HÁBITOS Y ENERGÍA FEMENINA
                </p>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-220">
                  Un bono para ayudarte a elevar tu imagen, tus hábitos, tu
                  energía y tu presencia. Porque una reina también se construye
                  en los detalles de cómo se ve, cómo se cuida y cómo se
                  sostiene.
                </p>
                <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-221">
                  <CrownIcon className="h-5 w-5" data-id="element-222" /> LLÉVATELO GRATIS
                </div>
                <div className="mt-4 flex items-center gap-2" data-id="element-223">
                  <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-224">
                    ARS 12.990
                  </span>
                  <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-225">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* Bono 6 */}
            <div className="bg-black/60 rounded-3xl border border-[#d4af37]/30 p-6 md:p-10 flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12 hover:border-[#d4af37]/60 transition-colors group" data-id="element-226">
              <div className="w-full md:w-1/2 relative" data-id="element-227">
                <img src="https://cdn.magicpatterns.com/uploads/nQfkcXVAicWcnXyStYeNwK/7.png" alt="Playlist de Reina Empoderada" className="w-full h-auto rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-228" />
              </div>
              <div className="w-full md:w-1/2 text-left md:text-right" data-id="element-229">
                <div className="inline-block bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] px-4 py-1.5 rounded-full text-sm font-bold mb-4" data-id="element-230">
                  BONO 6
                </div>
                <h3 className="text-3xl font-black text-white mb-2 font-serif uppercase" data-id="element-231">
                  PLAYLIST DE REINA EMPODERADA
                </h3>
                <p className="text-slate-400 text-lg leading-relaxed mb-6" data-id="element-232">
                  La lista de reproducción para tu nueva mentalidad de reina.
                  Música para empoderarte, elevar tu vibración y conectar con tu
                  versión más magnética.
                </p>
                <div className="flex flex-col items-start md:items-end gap-4" data-id="element-233">
                  <div className="inline-flex items-center gap-2 bg-black border-2 border-[#d4af37] text-[#d4af37] px-6 py-2 rounded-full font-black uppercase tracking-widest" data-id="element-234">
                    <CrownIcon className="h-5 w-5" data-id="element-235" /> LLÉVATELO GRATIS
                  </div>
                  <div className="flex items-center gap-2" data-id="element-236">
                    <span className="line-through font-bold text-lg text-[#F31515]" data-id="element-237">
                      ARS 24.990
                    </span>
                    <span className="bg-[#d4af37] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-238">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 11. Resumen de Ahorro */}
      <section className="w-full bg-[#050000] py-20 px-4 border-y border-white/5 relative overflow-hidden pt-[25px] pb-[25px]" data-id="element-239">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-[#d4af37]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-240"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-241">
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase font-serif mb-12" data-id="element-242">
            UN PAQUETE DE TRANSFORMACIÓN COMPLETO
          </h2>

          <div className="bg-black/60 rounded-[2.5rem] border-2 border-[#d4af37] p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.15)]" data-id="element-243">
            <p className="text-[#d4af37] font-black text-lg md:text-xl uppercase tracking-[0.2em] mb-6" data-id="element-244">
              <span className="inline-block neon-emoji" data-id="element-245">💰</span> SOLO EN BONOS
              TE LLEVÁS:
            </p>

            <div className="flex flex-col items-center justify-center gap-4 mb-8" data-id="element-246">
              <span className="text-3xl md:text-4xl line-through font-bold text-[#F41919]" data-id="element-247">
                ARS 111.940
              </span>
              <div className="text-6xl md:text-8xl font-black drop-shadow-[0_0_20px_rgba(255,255,255,0.3)] text-[#DED700]" data-id="element-248">
                GRATIS
              </div>
            </div>

            <div className="inline-flex items-center gap-3 bg-red-950/50 border border-[#d4af37]/50 px-8 py-4 rounded-2xl mb-8" data-id="element-249">
              <SparklesIcon className="h-6 w-6 text-[#d4af37]" data-id="element-250" />
              <span className="text-xl md:text-2xl font-bold text-[#d4af37] uppercase tracking-widest" data-id="element-251">
                6 REGALOS EXCLUSIVOS INCLUIDOS
              </span>
            </div>

            <p className="text-slate-300 text-lg md:text-xl font-light leading-relaxed max-w-2xl mx-auto" data-id="element-252">
              Aprovechando la oferta de hoy, no solo te llevás el reto de 21
              días, sino que desbloqueás{' '}
              <span className="text-white font-bold" data-id="element-253">
                más de $110.000 en contenido extra
              </span>{' '}
              sin pagar un peso más.
            </p>
          </div>
        </div>
      </section>

      {/* 13. Contador (Urgencia antes de la oferta) */}
      <UrgencyModule data-id="element-254" />

      {/* 12. Resumen de la oferta */}
      <section id="compra" className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1a0505] via-black to-black py-20 px-4 relative overflow-hidden pt-[25px] pb-[25px]" data-id="element-255">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-256">
          <div className="bg-black rounded-[2.5rem] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.8),0_0_40px_rgba(212,175,55,0.15)] overflow-hidden border-2 border-[#d4af37] relative" data-id="element-257">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#d4af37]" data-id="element-258"></div>

            <div className="p-8 md:p-12 text-center" data-id="element-259">
              <h2 className="text-3xl md:text-4xl font-black text-white mb-8 uppercase font-serif tracking-widest" data-id="element-260">
                TODO LO QUE VAS A RECIBIR HOY
              </h2>

              <div className="text-left max-w-xl mx-auto mb-10" data-id="element-261">
                <div className="bg-black/60 p-5 rounded-xl border-2 border-[#d4af37] shadow-[0_0_25px_rgba(212,175,55,0.5),inset_0_0_15px_rgba(212,175,55,0.15)]" data-id="element-262">
                  <p className="text-xs text-[#d4af37] font-black mb-1 uppercase tracking-widest drop-shadow-[0_0_8px_rgba(212,175,55,0.8)]" data-id="element-263">
                    PROGRAMA PRINCIPAL
                  </p>
                  <p className="text-xl text-[#d4af37] font-black drop-shadow-[0_0_12px_rgba(212,175,55,0.9)]" data-id="element-264">
                    TRATO DE REINA — RETO DE 21 DÍAS
                  </p>
                </div>

                {/* Signo + que conecta el producto principal con los bonos */}
                <div className="flex justify-center my-4" aria-hidden="true" data-id="element-265">
                  <span className="flex h-12 w-12 rounded-full bg-[#d4af37] text-black font-black shadow-[0_0_25px_rgba(212,175,55,0.7)] text-[40px] flex-row items-end justify-center" data-id="element-266">
                    +
                  </span>
                </div>

                {/* Bonos gratis incluidos en la misma oferta, resaltados en dorado */}
                <div className="relative rounded-2xl border-2 border-[#d4af37] bg-[#d4af37]/5 p-4 md:p-5 shadow-[0_0_25px_rgba(212,175,55,0.35),inset_0_0_15px_rgba(212,175,55,0.1)]" data-id="element-267">
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#d4af37] text-black text-xs font-black uppercase tracking-widest px-4 py-1 rounded-full shadow-[0_0_15px_rgba(212,175,55,0.6)] whitespace-nowrap" data-id="element-268">
                    + 6 BONOS GRATIS INCLUIDOS
                  </span>
                  <div className="space-y-4 mt-3" data-id="element-269">
                    {['Comunidad Privada Mujeres con Trato de Reina', 'Mujer de Alto Valor', 'Desbloqueá tu Magnetismo Femenino', 'La Biblia de las Reinas', 'Glow Up de Reina', 'Playlist de Reina Empoderada'].map((bono, i) => <div key={i} className="flex items-center justify-between bg-black/40 p-3 rounded-xl border border-[#d4af37]/30" data-id="element-270">
                        <div data-id="element-271">
                          <span className="text-xs text-[#d4af37] font-bold mr-2" data-id="element-272">
                            BONO {i + 1}
                          </span>
                          <span className="text-slate-200" data-id="element-273">{bono}</span>
                        </div>
                        <span className="text-[#d4af37] font-black text-sm uppercase tracking-wider" data-id="element-274">
                          GRATIS
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>

              <div className="mb-8" data-id="element-275">
                <p className="text-xl line-through mb-2 font-medium text-[#F92F2F]" data-id="element-276">
                  VALOR TOTAL: $85.000 ARS
                </p>
                <p className="font-bold uppercase tracking-widest mb-2 text-[#FFFFFF] text-[17px]" data-id="element-277">
                  HOY ACCEDÉS A TODO POR:
                </p>
                <p className="md:text-7xl font-black drop-shadow-[0_0_15px_rgba(255,255,255,0.2)] text-[60px] text-[#D4AF37]" data-id="element-278">
                  $19.990{' '}
                  <span className="text-[26px] text-[#D4AF37]" data-id="element-279">ARS</span>
                </p>
                <p className="text-white font-bold text-lg md:text-xl mt-2" data-id="element-280">
                  En hasta 3 cuotas
                </p>
              </div>

              <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#d4af37] text-black font-black md:text-2xl py-6 rounded-xl border-2 border-[#f3e5ab] shadow-[0_0_25px_rgba(212,175,55,0.7),0_0_55px_rgba(212,175,55,0.5),inset_0_0_15px_rgba(255,255,255,0.25)] hover:shadow-[0_0_40px_rgba(212,175,55,0.95),0_0_80px_rgba(212,175,55,0.6),inset_0_0_18px_rgba(255,255,255,0.3)] transform hover:scale-105 transition-all duration-300 uppercase animate-pulse-slow text-[25px]" data-id="element-281">
                ❤️‍🔥QUIERO MI TRATO DE REINA❤️‍🔥
              </a>

              {/* Cinta de beneficios que se desplaza de derecha a izquierda */}
              <div className="mt-6 -mx-8 md:-mx-12 overflow-hidden border-y border-[#d4af37]/30 bg-[#d4af37]/5 py-3 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]" data-id="element-282">
                <div className="flex w-max animate-marquee" data-id="element-283">
                  {[0, 1].map(dup => <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1} data-id="element-284">
                      {['Pago único', 'Acceso inmediato', 'Material digital', 'Acceso de por vida', 'Incluye 6 bonos gratis'].map((tag, i) => <span key={i} className="mx-4 flex items-center gap-2 text-sm md:text-base font-black uppercase tracking-widest text-[#d4af37] whitespace-nowrap" data-id="element-285">
                          <SparklesIcon className="h-4 w-4 shrink-0" data-id="element-286" />
                          {tag}
                        </span>)}
                    </div>)}
                </div>
              </div>

              <div className="mt-8 flex justify-center" data-id="element-287">
                <img src="https://cdn.magicpatterns.com/uploads/9S5H48vSfQwVvjEfJSxxJW/WhatsApp_Image_2022-06-17_at_20.09.48_480x480.webp" alt="Compra 100% Verificada Mercado Pago" className="w-full max-w-md h-auto rounded-2xl shadow-lg border border-white/5" data-id="element-288" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 15. Garantía Premium Neon */}
      <section className="w-full bg-[#050000] py-24 px-4 border-y border-[#d4af37]/20 relative overflow-hidden pt-[25px] pb-[25px]" data-id="element-289">
        {/* Neon Glow Effects */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-64 bg-[#d4af37]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-290"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-291">
          <div className="bg-black/40 backdrop-blur-xl rounded-[3rem] border-2 border-[#d4af37] p-8 md:p-16 shadow-[0_0_50px_rgba(212,175,55,0.2)] relative overflow-hidden" data-id="element-292">
            {/* Inner Neon Border */}
            <div className="absolute inset-0 border border-[#d4af37]/30 rounded-[3rem] m-2" data-id="element-293"></div>

            <div className="text-center relative z-10" data-id="element-294">
              <div className="relative inline-block mb-8" data-id="element-295">
                <div className="absolute inset-0 bg-[#d4af37] blur-2xl opacity-20 animate-pulse" data-id="element-296"></div>
                <ShieldIcon className="h-20 w-20 text-[#d4af37] relative drop-shadow-[0_0_15px_rgba(212,175,55,0.8)]" data-id="element-297" />
              </div>

              <h2 className="text-4xl md:text-6xl font-black text-white uppercase font-serif mb-8 tracking-tighter leading-tight" data-id="element-298">
                COMPRÁ CON{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#d4af37] drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-299">
                  TOTAL TRANQUILIDAD
                </span>
              </h2>

              <div className="bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-2xl py-4 px-6 inline-block mb-10" data-id="element-300">
                <p className="text-[#d4af37] font-black text-xl md:text-2xl uppercase tracking-widest" data-id="element-301">
                  <span className="inline-block neon-emoji" data-id="element-302">🛡️</span> GARANTÍA
                  DE HIERRO DE 7 DÍAS
                </p>
              </div>

              <div className="space-y-6 text-left max-w-2xl mx-auto" data-id="element-303">
                <p className="text-xl md:text-2xl text-white font-medium leading-relaxed text-center" data-id="element-304">
                  "Si el programa no es lo que esperabas,{' '}
                  <span className="text-[#d4af37] underline decoration-wavy underline-offset-8" data-id="element-305">
                    te devolvemos el 100% de tu dinero
                  </span>
                  ."
                </p>

                <p className="text-lg text-slate-300 leading-relaxed text-center italic" data-id="element-306">
                  Queremos que entres hoy mismo sin ningún riesgo. Accedé al
                  material, empezá el reto, disfrutá de los bonos y, si en los
                  primeros 7 días sentís que esto no es para vos, nos escribís y
                  te reintegramos el total de tu inversión. Sin preguntas, sin
                  vueltas y sin resentimientos.
                </p>
              </div>

              <div className="mt-12 flex flex-wrap justify-center gap-6" data-id="element-307">
                <div className="flex items-center gap-2 text-[#d4af37] font-bold uppercase tracking-tighter" data-id="element-308">
                  <LockIcon className="h-5 w-5" data-id="element-309" />
                  <span data-id="element-310">Pago 100% Seguro</span>
                </div>
                <div className="flex items-center gap-2 text-[#d4af37] font-bold uppercase tracking-tighter" data-id="element-311">
                  <CheckIcon className="h-5 w-5" data-id="element-312" />
                  <span data-id="element-313">Devolución Garantizada</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. Preguntas frecuentes */}
      <section className="w-full bg-black py-20 px-4 relative overflow-hidden pt-[25px] pb-[25px] mt-[-25px] mb-[-25px]" data-id="element-314">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-315">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-12 text-center uppercase font-serif" data-id="element-316">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-317">
            {[{
            q: '¿Cómo recibo el programa?',
            a: 'Una vez realizado el pago, recibirás un correo electrónico con el acceso inmediato a todo el material digital.'
          }, {
            q: '¿El acceso es inmediato?',
            a: 'Sí, el acceso es 100% inmediato y automático tras la confirmación del pago.'
          }, {
            q: '¿Necesito estar en pareja?',
            a: 'No. Este reto es para vos, para trabajar en tu energía y tus estándares, estés soltera, conociendo a alguien o en pareja.'
          }, {
            q: '¿Puedo hacerlo desde el celular?',
            a: 'Sí, todo el material está optimizado para que lo puedas leer y aplicar desde cualquier dispositivo.'
          }, {
            q: '¿Cómo accedo a la comunidad privada?',
            a: 'Dentro del material del programa encontrarás el enlace exclusivo para unirte a nuestro grupo privado de Telegram.'
          }, {
            q: '¿Los 6 bonos están incluidos?',
            a: 'Sí, al comprar hoy por $19.990 ARS te llevás el programa principal y los 6 bonos de regalo.'
          }, {
            q: '¿La Playlist de Reina Empoderada también está incluida gratis?',
            a: '¡Por supuesto! Es el Bono #6 y está incluido sin costo adicional.'
          }, {
            q: '¿Por cuánto tiempo tengo acceso?',
            a: 'El acceso es de por vida. Podés hacer el reto a tu propio ritmo y volver a leerlo cuando lo necesites.'
          }, {
            q: '¿Qué pasa si siento que no es para mí?',
            a: 'Tenés nuestra garantía de satisfacción de 7 días. Si sentís que no es lo que esperabas, podés pedir la devolución.'
          }].map((faq, index) => <div key={index} className="bg-[#111] rounded-2xl overflow-hidden border border-white/10" data-id="element-318">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#1a1a1a] transition-colors" data-id="element-319">
                  <span className="text-lg font-bold text-slate-200" data-id="element-320">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-6 w-6 text-[#d4af37] transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-321" />
                </button>
                {openFaq === index && <div className="px-6 pb-6" data-id="element-322">
                    <p className="text-slate-400" data-id="element-323">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* 17. Cierre final */}
      <section className="w-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-red-950/40 via-black to-black py-24 px-4 border-t border-[#d4af37]/20 relative overflow-hidden pt-[2px] pb-[2px]" data-id="element-324">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-325">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-8 uppercase font-serif leading-tight pt-[25px] pb-[25px]" data-id="element-326">
            TU VERSIÓN MÁS SEGURA, FEMENINA Y PODEROSA{' '}
            <span className="text-[#d4af37]" data-id="element-327">TE ESTÁ ESPERANDO</span>
          </h2>

          <p className="text-xl md:text-2xl text-slate-300 mb-12 font-light leading-relaxed max-w-3xl mx-auto" data-id="element-328">
            No necesitás seguir persiguiendo amor. No necesitás seguir
            conformándote con migajas. No necesitás desaparecer dentro de una
            relación para conseguir que alguien te elija.
            <br data-id="element-329" />
            <br data-id="element-330" />
            <span className="font-medium text-white" data-id="element-331">
              Hoy podés empezar a recuperar tu energía, tu magnetismo y tu
              corona.
            </span>
          </p>

          <div className="mb-10" data-id="element-332">
            <p className="line-through text-xl mb-2 text-[#FF0000]" data-id="element-333">
              Antes: $85.000 ARS
            </p>
            <p className="text-3xl text-white font-bold uppercase tracking-widest mb-2" data-id="element-334">
              Hoy:
            </p>
            <p className="text-6xl font-black text-[#d4af37] drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-335">
              $19.990 ARS
            </p>
          </div>

          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-[#d4af37] to-[#aa8c2c] text-black font-black text-xl md:text-3xl px-12 py-6 rounded-xl shadow-[0_0_40px_rgba(212,175,55,0.4)] hover:shadow-[0_0_60px_rgba(212,175,55,0.6)] transform hover:scale-105 transition-all duration-300 uppercase animate-pulse-slow" data-id="element-336">
            SÍ, QUIERO RECIBIR MI TRATO DE REINA
          </a>
          <p className="text-sm text-slate-400 mt-6 font-medium tracking-wide" data-id="element-337">
            Acceso inmediato · Pago único · Incluye 6 bonos gratis
          </p>
        </div>
      </section>

      {/* 18 & 19. Aviso responsable & Footer */}
      <footer className="w-full bg-black py-12 px-4 border-t border-white/10 text-center" data-id="element-338">
        <div className="max-w-4xl mx-auto" data-id="element-339">
          <p className="text-xs text-slate-600 mb-6 leading-relaxed" data-id="element-340">
            AVISO RESPONSABLE: Este producto no garantiza resultados
            específicos, ya que los mismos dependen del compromiso y la
            aplicación individual de cada persona. La información compartida
            tiene fines educativos y de desarrollo personal, y no reemplaza la
            terapia psicológica o el asesoramiento profesional.
          </p>
          <p className="text-sm text-slate-500 font-medium" data-id="element-341">
            &copy; {new Date().getFullYear()} Trato de Reina. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}